import { render, staticRenderFns } from "./CartCheckoutFinalize.vue?vue&type=template&id=0963fef4"
import script from "./CartCheckoutFinalize.vue?vue&type=script&lang=js"
export * from "./CartCheckoutFinalize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports